import {DataTransferObject} from './DataTransferObject';
import {PublicTransportConfigDTO} from './PublicTransportConfigDTO';
import {AdditionalOrderItemConfiguration} from '../Models/AdditionalOrderItemConfiguration';

export class AdditionalOrderItemConfigurationDTO extends DataTransferObject {
  public id: string | number = '-1';
  public parentOrderItemId: string | number | null = null;
  public orderItemId: string | number = 0;
  public personalUse: boolean | null = null;
  public publicTransportConfig: PublicTransportConfigDTO | null = null;
  public productId: number | null = null;
  public slotId: number | null = null;

  fromModel(orderItemConfig: AdditionalOrderItemConfiguration): AdditionalOrderItemConfigurationDTO {
    const orderItemConfigDTO = new AdditionalOrderItemConfigurationDTO();
    orderItemConfigDTO.id = orderItemConfig.id;
    orderItemConfigDTO.orderItemId = orderItemConfig.orderItemId;
    orderItemConfigDTO.personalUse = orderItemConfig.personalUse;
    orderItemConfigDTO.parentOrderItemId = orderItemConfig.parentOrderItemId;
    orderItemConfigDTO.productId = orderItemConfig.productId;
    orderItemConfigDTO.slotId = orderItemConfig.slotId;
    if (orderItemConfig.publicTransportConfig) {
      const pubTransConfig = new PublicTransportConfigDTO();
      orderItemConfigDTO.publicTransportConfig = pubTransConfig.fromModel(orderItemConfig.publicTransportConfig);
    }

    return orderItemConfigDTO;
  }

  static clone(orderItemConfigDTO: AdditionalOrderItemConfigurationDTO): AdditionalOrderItemConfigurationDTO {
    return new AdditionalOrderItemConfigurationDTO();
  }
}
